document.addEventListener('DOMContentLoaded', () => {
  const dropDownTrigger = document.querySelectorAll('[data-dropdown-trigger]');
  const dropDownMobile = document.querySelectorAll('.drawer-button-mb');
  const subMenuMobile = document.querySelectorAll('.submenu-mb');
  const svgIcon = `<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.286 6.011 11.265.787a.47.47 0 0 0 0-.647l-.006-.006a.43.43 0 0 0-.625 0l-4.688 4.92L1.261.134a.43.43 0 0 0-.626 0L.63.14a.47.47 0 0 0 0 .647L5.608 6.01a.47.47 0 0 0 .678 0" fill="#414042"/></svg>`;

  dropDownTrigger.forEach((el) => {
    el.insertAdjacentHTML('beforeend', svgIcon);
  });

  dropDownMobile.forEach((el) => {
    el.insertAdjacentHTML('beforeend', svgIcon);
  });

  dropDownMobile.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.classList.contains('active')) {
        button.classList.remove('active');
      } else {
        button.classList.add('active');
      }
      subMenuMobile.forEach((menu) => {
        if (menu.style.display === 'flex') {
          menu.style.display = 'none';
          return;
        }
        menu.style.display = 'flex';
      });
    });
  });

  new Swiper('.swiper', {
    slidesPerView: 1,
  });
});
